module.exports = __webpack_public_path__ + "img/1C.0a303f21.png";